module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-for-use@3x.0e70907f.jpg";